import { getErrorMessage } from "../constants";
import analytics from "./analytics";

/**
 * Extract error code from response
 * @param error
 * @returns {*|string}
 */
export const getErrorCode = (error) => (
  error?.response?.data?.identity?.errors[0].errorCode
    || error?.response?.data?.account?.errors?.[0].errorCode
    || error?.response?.data?.errors?.[0].errorCode
    || error?.response?.data?.errorCode
    ||"GEN_ERR_500"
);

export const handleApiError = (error, pageSection) => {
  const errorCode = getErrorCode(error);
  const errorMessage = getErrorMessage(errorCode);
  analytics.postErrorEvent(pageSection, errorCode, errorMessage);
  return errorMessage;
};
